<template>
  <div class="white--text" v-if="!!pageLoaded">
    <!-- <v-container class="pa-0">
            <v-row row wrap>
                <v-col cols="12" md="4" offset-md="4"> -->
    <v-container fluid :class="{ 'pa-0': $vuetify.breakpoint.smAndDown }">
      <v-row no-gutters>
        <v-col md="4" offset-md="4">
          <v-stepper v-model="el">
            <v-stepper-items>
              <v-stepper-content
                class="pa-0"
                v-for="(stepperItem, index) in stepComponents"
                :key="`stepper-${index}`"
                :step="`${index + 1}`"
              >
                <component
                  @skipStep="handleStepSkip"
                  @changeStep="handleStepChange($event)"
                  :lastStep="index == lastStepNext-1"
                  :dataLoading="dataLoading"
                  :currentPerson="currentPerson"
                  :is="stepperItem"
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-btn class="mt-5" @click="signOut" small text block>
          QUIT REGISTRATION
        </v-btn>
      </v-row>      
    </v-container>

    <!-- </v-col>
            </v-row>
        </v-container> -->
  </div>
</template>

<script>
import StepOne from "@/components/StepOne.vue";
import StepTwo from "@/components/StepTwo.vue";
import StepTwoNext from "@/components/StepTwoNext.vue";
import StepThree from "@/components/StepThree.vue";
import StepFour from "@/components/StepFour.vue";
import { mapGetters } from "vuex";
import { appSignOut } from "@/services/Auth";
import {
  addPerson,
  updatePerson,
  getInfluencerSync,
} from "./../api/Persons";

// const stepComponents = [StepOne, StepTwo, StepThree, StepFour, StepFive]

// in this case only 3 steps are used currently
const stepComponents = [StepOne, StepTwo, StepTwoNext, StepThree, StepFour];

export default {
  //  beforeRouteEnter(to, from, next) {
  //    from.path == "/account" ? next("/") : next();
  //  },
  data() {
    return {
      el: 1,
      currentPerson: {},
      userCreated: false,
      dataLoading: false,
      pageLoaded: false,
    };
  },
  computed: {
    stepComponents() {
      return stepComponents;
    },
    currentRoute() {
      return this.$route.query;
    },
    stepsCompleted() {
      return this.el == this.lastStepNext
    },
    lastStepNext() {
      return this.currentUser.isAnonymous == true? 6 : 5
    },
    // ...mapGetters(["currentPerson", "loading"])
    ...mapGetters(["loading", "currentUser"]),
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepTwoNext
  },
  // beforeCreate() {
  //     triggerAction("fetchCurrentPerson")
  //     .then(() => {
  //         // if (this.currentPerson.isArtist !== null) { this.$router.replace("/") }
  //     })
  //     .catch(() => {})
  // },
  async created() {
    getInfluencerSync(this.currentUser.uid, this.onPersonDataFetch);
  },
  methods: {
    onPersonDataFetch(personData) {
      console.log(personData)
      this.currentPerson = personData;
      if (!!personData.id) {
        this.userCreated = true;
        if (personData.onboarded) {
          this.$router.replace(this.el == this.lastStepNext? "/account" : "/").catch(() => {}) 
        }
      }
      this.pageLoaded = true;
    },
    async handleStepChange(data) {
      // console.log(data);
      // this.nextStep();

      // UPDATE PERSON DATA

      this.dataLoading = true;

      console.log(data)

      try {
        if ((this.el == 1) & !this.userCreated)
          await addPerson({ ...data, id: this.currentUser.uid });
        else await updatePerson(this.currentUser.uid, data);
        this.nextStep();
      } catch (e) {
        console.log(e);
      }

      this.dataLoading = false;
    },
    handleStepSkip() {
      this.nextStep(this);
    },
    nextStep() {
      console.log("running next step");
      this.el += 1;
      //this.nextRoute();
      // return;

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 700);

      if (this.stepsCompleted) {
        setTimeout(() => {
          this.$store.commit("SET_SNACKBAR", {
            message: "Profile set up successfully",
          });
          this.$router.replace("/account");
        }, 300);
      } else {
        this.nextRoute();
      }
    },
    nextRoute() {
      this.$router
        .push({ path: "getting-started", query: { step: this.el } })
        .catch((e) => {});
    },
    signOut() {
      appSignOut()
      .then(() => {
        window.location = '/'
      })
    },
  },
  watch: {
    currentRoute: {
      handler(query) {
        const step = parseInt(query.step);
        if (step < this.el) {
          this.el = step;
        }
      },
      deep: true,
    },
  },
};
</script>